<table class="mat-datetimepickerT2-calendar-table">
  <thead class="mat-datetimepickerT2-calendar-table-header"></thead>
  <tbody (@slideCalendar.done)="_calendarStateDone()" (selectedValueChange)="_yearSelected($event)"
    [@slideCalendar]="_calendarState" [activeCell]="_getActiveCell()" [numCols]="4" [rows]="_years"
    [selectedValue]="_selectedYear" [todayValue]="_todayYear" allowDisabledSelection="true"
    mat-datetimepickerT2-calendar-body role="grid">
  </tbody>
</table>
